/**
 * Scan session UI state for dedicated scanning workspace (lanes).
 * Not the Shopify cart — tracks resolve/batch lifecycle only.
 */
(function () {
  'use strict';

  var STATUSES = {
    ACCEPTED: 'accepted',
    RESOLVING: 'resolving',
    RESOLVED: 'resolved',
    QUEUED: 'queued',
    SENDING: 'sending',
    COMMITTED: 'committed',
    FAILED: 'failed'
  };

  function ScanSessionStore() {
    this._entries = [];
    this._listeners = [];
    this._idSeq = 0;
  }

  ScanSessionStore.prototype._emit = function () {
    var self = this;
    this._listeners.forEach(function (fn) {
      try {
        fn(self._entries.slice());
      } catch (e) {
        console.warn('[ScanSessionStore] listener error', e);
      }
    });
  };

  ScanSessionStore.prototype.subscribe = function (fn) {
    var self = this;
    this._listeners.push(fn);
    try {
      fn(this._entries.slice());
    } catch (e) {}
    return function unsubscribe() {
      self._listeners = self._listeners.filter(function (x) {
        return x !== fn;
      });
    };
  };

  ScanSessionStore.prototype.add = function (partial) {
    var id = 's' + String(++this._idSeq) + '-' + Date.now().toString(36);
    var entry = Object.assign(
      {
        id: id,
        barcode: '',
        title: '',
        variantId: null,
        quantity: 1,
        status: STATUSES.ACCEPTED,
        error: null,
        batchId: null,
        at: Date.now()
      },
      partial || {}
    );
    this._entries.unshift(entry);
    this._trim();
    this._emit();
    return id;
  };

  ScanSessionStore.prototype.update = function (id, patch) {
    var ix = this._entries.findIndex(function (e) {
      return e.id === id;
    });
    if (ix < 0) return false;
    Object.assign(this._entries[ix], patch || {});
    this._emit();
    return true;
  };

  ScanSessionStore.prototype.findById = function (id) {
    return this._entries.find(function (e) {
      return e.id === id;
    });
  };

  ScanSessionStore.prototype._trim = function () {
    var max = 120;
    if (this._entries.length > max) {
      this._entries.length = max;
    }
  };

  ScanSessionStore.prototype.getEntries = function () {
    return this._entries.slice();
  };

  ScanSessionStore.prototype.clearCommittedOlderThan = function (maxKeep) {
    var committed = this._entries.filter(function (e) {
      return e.status === STATUSES.COMMITTED;
    });
    if (committed.length <= (maxKeep || 30)) return;
    var toRemove = committed.slice(maxKeep || 30);
    var removeIds = new Set(toRemove.map(function (e) {
      return e.id;
    }));
    this._entries = this._entries.filter(function (e) {
      return !removeIds.has(e.id);
    });
    this._emit();
  };

  window.IsalbiScanSessionStore = ScanSessionStore;
  window.IsalbiScanSessionStatuses = STATUSES;
})();
